import { Box, Typography, styled } from "@mui/material";
import { colors } from "../../../../theme/colors";

export const AppointmentContainer = styled(Box)(({ theme }) => ({
  marginBottom: "16px",
  wordBreak: "break-word",
  overflowWrap: "break-word",
  [theme.breakpoints.down("sm")]: {
    marginBottom: "12px",
    "& p": { wordBreak: "break-word", overflowWrap: "break-word" },
    "& span": { wordBreak: "break-word", overflowWrap: "break-word" },
    "& h1": { wordBreak: "break-word", overflowWrap: "break-word" },
    "& h2": { wordBreak: "break-word", overflowWrap: "break-word" },
    "& h3": { wordBreak: "break-word", overflowWrap: "break-word" },
    "& h4": { wordBreak: "break-word", overflowWrap: "break-word" },
    "& h5": { wordBreak: "break-word", overflowWrap: "break-word" },
    "& h6": { wordBreak: "break-word", overflowWrap: "break-word" },
    "& div": { wordBreak: "break-word", overflowWrap: "break-word" },
  },
}));

export const AppointmentHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "24px",
  marginBottom: "8px",
  transition: "gap 0.2s ease, margin-bottom 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
  },
}));

export const AppointmentTitle = styled(Typography)(({ theme }) => ({
  fontSize: "18px",
  fontWeight: 600,
  color: colors.text.action,
  fontFamily: "Sora",
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "12px",
  transition: "font-size 0.2s ease, gap 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    fontSize: "16px",
    gap: "8px",
  },
}));

export const AppointmentBadge = styled(Box)({
  backgroundColor: colors.background.darkBlue,
  color: colors.background.secondary,
  padding: "4px 12px",
  borderRadius: "4px",
  fontSize: "12px",
  fontWeight: 600,
  fontFamily: "Sora",
});

export const AppointmentSubtitle = styled(Typography)({
  fontSize: "18px",
  fontWeight: 600,
  color: colors.text.link,
  fontFamily: "Sora",
});

export const AppointmentMeta = styled(Box)(({ theme }) => ({
  display: "flex",
  whiteSpace: "nowrap",
  gap: "24px",
  transition: "gap 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    gap: "16px",
    flexWrap: "wrap",
  },
}));

export const MetaItem = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  transition: "gap 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    gap: "2px",
  },
}));

export const MetaLabel = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  color: colors.text.primary,
  fontWeight: 700,
  fontFamily: "Nunito",
  transition: "font-size 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const MetaValue = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 700,
  color: colors.text.primary,
  fontFamily: "Nunito",
  transition: "font-size 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const AppointmentDescription = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  color: colors.text.primary,
  fontStyle: "italic",
  fontFamily: "Nunito",
  marginBottom: "16px",
  transition: "font-size 0.2s ease, margin-bottom 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
    marginBottom: "12px",
  },
}));

export const ProcedureCard = styled(Box)(({ theme }) => ({
  border: `1px solid ${colors.border.medium}`,
  boxShadow: "0 3px 16px 0 rgba(51, 84, 150, 0.07)",
  borderRadius: "12px",
  padding: "18px 24px",
  marginBottom: "12px",
  backgroundColor: colors.background.secondary,
  transition:
    "padding 0.2s ease, margin-bottom 0.2s ease, border-radius 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    padding: "16px",
    marginBottom: "8px",
    borderRadius: "8px",
  },
}));

export const ProcedureTitle = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 600,
  color: colors.text.link,
  fontFamily: "Sora",
  marginBottom: "8px",
  transition: "font-size 0.2s ease, margin-bottom 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
    marginBottom: "6px",
  },
}));

export const ProcedureCdtExplanation = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 400,
  color: colors.text.primary,
  fontFamily: "Nunito",
  marginBottom: "10px",
  transition: "font-size 0.2s ease, margin-bottom 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    fontSize: "13px",
    marginBottom: "6px",
  },
}));

export const ProcedureDescription = styled(Typography)({
  fontSize: "16px",
  color: colors.text.primary,
  fontFamily: "Nunito",
  marginBottom: "24px",
});

export const ProcedureLayout = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "24px",
  alignItems: "flex-end",
  transition: "gap 0.2s ease, flex-direction 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "12px",
  },
}));

export const ProcedureContentColumn = styled(Box)(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  transition: "width 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}));

export const ProcedureDetailsColumn = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  width: "320px",
  flexShrink: 0,
  transition: "width 0.2s ease, flex-direction 0.2s ease, gap 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    flexDirection: "column",
    gap: "8px",
  },
}));

export const ProcedureDetails = styled(Box)({
  display: "flex",
  gap: "24px",
  alignItems: "flex-start",
});

export const ProcedureDetailItem = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  flexShrink: 0,
});

export const ProcedureDetailItemCdt = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  width: "120px",
  flexShrink: 0,
  fontSize: "14px",
  transition: "width 0.2s ease, flex-direction 0.2s ease, gap 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
  },
}));

export const ProcedureDetailItemDuration = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  width: "60px",
  flexShrink: 0,
  fontSize: "14px",
  transition: "width 0.2s ease, flex-direction 0.2s ease, gap 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
  },
}));

export const ProcedureDetailItemFee = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  flexShrink: 0,
  fontSize: "14px",
  transition: "width 0.2s ease, flex-direction 0.2s ease, gap 0.2s ease",
  width: "170px",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "8px",
  },
}));

export const ProcedureDetailLabel = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  color: colors.text.secondary,
  fontFamily: "Nunito",
  transition: "font-size 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));

export const ProcedureDetailValue = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: colors.text.primary,
  fontFamily: "Sora",
  transition: "font-size 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    fontSize: "13px",
  },
}));

export const ProcedureDetailHint = styled("span")({
  fontSize: "14px",
  fontWeight: 400,
  color: colors.text.primary,
  fontFamily: "Nunito",
  lineHeight: "22px",
  textWrap: "nowrap",
});
